import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/$alias/settings/scorecards/$scorecardId/',
)({
  component: RouteComponent,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: '/$alias/settings/scorecards/$scorecardId/criteria',
      params: params,
      search: search,
    })
  },
})

function RouteComponent() {
  return <div />
}
